
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram/[id]",
      function () {
        return require("private-next-pages/instagram/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram/[id]"])
      });
    }
  